import client1Img from "../assets/images/client1.jpg";
import client2Img from "../assets/images/client2.jpg";
import clientLeft1Img from "../assets/images/clientLeft1.png";
import clientRight1Img from "../assets/images/clientRight1.png";
import clientLeft2Img from "../assets/images/clientLeft2.png";
import clientRight2Img from "../assets/images/clientRight2.png";

export const reviewsData = [
  {
    id: 0,
    title: "An effortless process from start to launch",
    quote: "Working together was the best investment we made for our business this year. Our new website reflects the luxury feel of our brand so naturally. Our client inquiries doubled within the first three weeks of launching!",
    author: "Sophia & Marc, Studio Atelier Co.",
    link: "https://lightgoldenrodyellow-quetzal-387860.hostingersite.com/",
    images: {
      left: clientLeft1Img,
      center: client1Img,
      right: clientRight1Img,
    }
  },
  {
    id: 1,
    title: "An effortless process from start to launch",
    quote: "Working together was the best investment we made for our business this year. Our new website reflects the luxury feel of our brand so naturally. Our client inquiries doubled within the first three weeks of launching!",
    author: "Sophia & Marc, Studio Atelier Co.",
    link: "https://lightgoldenrodyellow-quetzal-387860.hostingersite.com/",
    images: {
      left: clientLeft2Img,
      center: client2Img,
      right: clientRight2Img,
    }
  }
];
